/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/443-tumblr2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zm-3.066 12.884c-.472.222-.9.378-1.281.469a5.522 5.522 0 01-1.241.134c-.506 0-.803-.063-1.191-.191s-.719-.309-.994-.544c-.275-.238-.463-.488-.569-.753s-.159-.65-.159-1.156V6.971h-1.5V5.408c.434-.141.938-.344 1.244-.606.309-.263.559-.578.744-.947.188-.369.316-.837.388-1.406h1.569v2.55H11v1.972H8.447v2.831c0 .641-.009 1.009.059 1.191s.238.369.422.475c.244.147.525.219.838.219.559 0 1.116-.181 1.669-.544v1.741z"/>'
  }
})
